import { UserProfileMenu } from './UserProfileMenu';
import { NotificationsModal } from './NotificationsModal';
import { NotificationsContext } from './NotificationsContext';
import { FeatureSelector } from './FeatureSelector';
import { AiOutlineBell } from 'react-icons/ai/index.js';
import { Flex, Icon } from '@chakra-ui/react';
import { useMemo, useState, useContext } from 'react';
import { Avatar } from '@ssar-app/uikit';

export const GeneralNav = () => {
  const [showNotifications, setShowNotifications] = useState(false);
  const { notifications } = useContext(NotificationsContext);
  const notifCount = useMemo(
    () => notifications.filter((notif) => !notif.isAccepted).length,
    [notifications],
  );
  const showFeatureSelector = true;
  return (
    <>
      <NotificationsModal
        showNotifications={showNotifications}
        setShowNotifications={setShowNotifications}
      />
      <Flex
        h={16}
        borderBottom='1px solid'
        borderColor='gray.300'
        mr={16}
        gap={4}
        justifyContent='end'
        alignItems='center'
      >
        {showFeatureSelector && <FeatureSelector />}
        <Avatar
          bg='primary'
          icon={<Icon as={AiOutlineBell} color='white' fontSize='md' />}
          hasBadge={notifCount > 0}
          onClick={() => setShowNotifications(true)}
          badgeProps={{
            backgroundColor: 'red !important',
            children: notifCount,
            color: 'white',
            minH: 5,
            minW: 5,
            fontSize: 'xs',
          }}
          mr={4}
          cursor='pointer'
        />
        <UserProfileMenu />
      </Flex>
    </>
  );
};
